<app-call-entry-item-response
  *ngIf="item.type == 'R'"
  [item]="item"
>
</app-call-entry-item-response>

<app-call-entry-item-compromise
  *ngIf="item.type == 'C'"
  [item]="item"
  [operator]="operator"
>
</app-call-entry-item-compromise>
